import Resource from '@/services/resources/common';

export default class DocumentTypeResource extends Resource {
  constructor(entrypoint = '/document_types', alias = 'DocumentType') {
    super(entrypoint, alias);
  }
}
